import React, { Children } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  icon: '⚡',
  title: 'Planificador Express "Clase en 10 Min"',
  highlight: '12 mapas',
  price: '$8.000'
}, {
  icon: '🎤',
  title: 'Banco de Aperturas y Cierres',
  highlight: '60+ recursos',
  price: '$9.000'
}, {
  icon: '🔄',
  title: 'Rotaciones Perfectas',
  highlight: '8 diagramas',
  price: '$8.000'
}, {
  icon: '📝',
  title: 'Kit de Evaluación + Certificados',
  highlight: '3 tests',
  price: '$10.000'
}, {
  icon: '🎵',
  title: 'Playlist Pedagógica ProfePack',
  highlight: '36 tandas',
  price: '$9.000'
}, {
  icon: '🗂️',
  title: 'Kit Imprimible de Fichas de Clase',
  highlight: '24 fichas',
  price: '$7.000'
}];
export function BonusSection() {
  return <section className="w-full bg-black py-14 sm:py-20 px-4" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        {/* Heading */}
        <motion.div className="text-center mb-8 sm:mb-10" initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-3">
          <p className="text-[#C8962E]/60 text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-4">
            INCLUIDOS SIN COSTO EXTRA
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-tight" data-id="element-5">
            Más los <span className="text-[#C8962E]" data-id="element-6">6 Bonos Estratégicos</span>
          </h2>
        </motion.div>

        {/* Compact bonus list */}
        <motion.div className="bg-white/[0.02] border border-[#C8962E]/15 rounded-2xl overflow-hidden mb-6" initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} data-id="element-7">
          {/* Gold top accent */}
          <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-[#C8962E]/40 to-transparent" data-id="element-8" />

          <motion.div className="divide-y divide-white/[0.04]" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.05
            }
          }
        }} data-id="element-9">
            {bonuses.map((bonus, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              x: -12
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-center gap-3 px-4 sm:px-5 py-3 sm:py-3.5 hover:bg-white/[0.03] transition-colors duration-200" data-id="element-10">
                {/* Icon */}
                <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#C8962E]/[0.08] flex items-center justify-center text-sm group-hover:bg-[#C8962E]/[0.14] transition-colors duration-300" data-id="element-11">
                  {bonus.icon}
                </span>

                {/* Title + highlight */}
                <div className="flex-1 min-w-0" data-id="element-12">
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-13">
                    <h3 className="text-white text-sm font-bold leading-snug truncate" data-id="element-14">
                      {bonus.title}
                    </h3>
                    <span className="text-[#C8962E]/80 text-[9px] font-bold bg-[#C8962E]/10 px-1.5 py-0.5 rounded flex-shrink-0" data-id="element-15">
                      {bonus.highlight}
                    </span>
                  </div>
                </div>

                {/* Price */}
                <div className="flex items-center gap-2 flex-shrink-0" data-id="element-16">
                  <span className="text-gray-600 line-through text-[11px] hidden sm:inline" data-id="element-17">
                    {bonus.price}
                  </span>
                  <span className="bg-[#C8962E]/15 text-[#C8962E] font-black text-[9px] px-2 py-0.5 rounded-full tracking-wide" data-id="element-18">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>

        {/* Total value summary — compact */}
        <motion.div className="flex items-center justify-center gap-3 sm:gap-4 py-3 px-5 border border-[#C8962E]/20 rounded-xl text-center" style={{
        background: 'linear-gradient(135deg, rgba(200,150,46,0.04) 0%, rgba(0,0,0,0.3) 100%)'
      }} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.15
      }} data-id="element-19">
          <p className="text-gray-500 text-xs sm:text-sm" data-id="element-20">
            Valor total: <span className="line-through" data-id="element-21">$51.000</span>
          </p>
          <span className="text-[#C8962E] text-sm sm:text-base font-black" data-id="element-22">
            🎁 GRATIS
          </span>
          <span className="text-gray-600 text-[10px] sm:text-xs hidden sm:inline" data-id="element-23">
            · Incluidos en las dos ofertas
          </span>
        </motion.div>
      </div>
    </section>;
}